<template>
  <div>
    <transition mode="out-in">
      <div v-if="$auth.ready()">
        <router-view :key="$route.path"></router-view>
      </div>
    </transition>

    <div v-if="!$auth.ready()">
      Loading ...
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      quoteInterval: null,
      lastPriceCheck: null
    }
  },
  methods: {
    getSpotPrices () {
      if (this.$auth.check()) {
        if (!this.lastPriceCheck || this.lastPriceCheck < Date.now() + 500) {
          this.$http.get('quote/all').then(response => {
            this.$bus.$emit('spot-price', response.body)
          }, response => {
            console.log(response)
          })
        }
      }
    },
    userDetails () {
      if (this.$auth.check()) {
        this.$http.get('auth/userDetails').then(response => {
          if (response.body && response.body.message) {
            this.$router.push({path: '/login'})
          }
        }, response => {
          console.log(response)
        })
      }
    }
  },
  beforeMount () {
    this.getSpotPrices()
  },
  mounted () {
    this.quoteInterval = window.setInterval(() => {
      this.getSpotPrices()
      this.userDetails()
    }, 10000)
  },
  beforeDestroy () {
    clearInterval(this.quoteInterval)
  },
  created () {
    this.$bus.$on('request-spot-price', ($event) => {
      // console.log('created -> event', event)
      this.getSpotPrices()
    })
  }
}
</script>

<style>
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';
</style>



// WEBPACK FOOTER //
// App.vue?eb02e9b6